import { URLS } from '@constants';

import { lazyRoute } from '@components/LazyRoute';
import { RouterSwitch } from '@components/RouterSwitch';

import { IRouteConfigComponent } from '@interfaces';

export const getRouter = async () => {
	const routes: IRouteConfigComponent[] = [
		{
			path: URLS.MAIN,
			component: await lazyRoute(async () => import('@containers/Main'), 'Main'),
		},
		{
			path: URLS.TARGETS_ITEM,
			component: await lazyRoute(async () => import('@containers/Target'), 'Target'),
		},
		{
			path: URLS.MENU,
			component: await lazyRoute(async () => import('@containers/Menu'), 'Menu'),
		},
		{
			path: URLS.CATALOG,
			component: await lazyRoute(async () => import('@containers/MenuCatalog'), 'MenuCatalog'),
		},
		{
			path: URLS.GRAPHS,
			component: await lazyRoute(async () => import('@containers/Graphs'), 'Graphs'),
		},
		{
			path: URLS.SETTINGS,
			component: await lazyRoute(async () => import('@containers/Settings'), 'Settings'),
		},
	];

	// eslint-disable-next-line new-cap
	const Pages = RouterSwitch(routes);

	return {
		routes,
		Router: {
			Pages,
		},
	};
};
